package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class TeamDto(
    val id: String,
    val name: String,
    val sportId: String,
    val imageUrl: String? = null,
    val kitHomeImageUrl: String? = null,
    val kitAwayImageUrl: String? = null,
    val formation: FormationDto? = null,
    val creatorId: String,
    val rating: Double,
    val membersCount: Int,
    val createdAt: String,
    val updatedAt: String
)

@Serializable
data class TeamWithMembersDto(
    val id: String,
    val name: String,
    val sportId: String,
    val imageUrl: String? = null,
    val kitHomeImageUrl: String? = null,
    val kitAwayImageUrl: String? = null,
    val formation: FormationDto? = null,
    val creatorId: String,
    val rating: Double,
    val members: List<TeamMemberDto>,
    val createdAt: String,
    val updatedAt: String
)

@Serializable
data class TeamMemberDto(
    val id: String,
    val userId: String,
    val username: String,
    val fullName: String? = null,
    val avatarUrl: String? = null,
    val overallRating: Double = 0.0,
    val position: String? = null,
    val club: String? = null,
    val country: String? = null,
    val cardImageUrl: String? = null,
    val cardAvatarUrl: String? = null,
    val cardAssetsBasePath: String? = null,
    val cardTextColor: String? = null,
    val roles: List<String>,
    val createdAt: String
)

@Serializable
data class CreateTeamRequest(
    val name: String,
    val sportId: String,
    val imageUrl: String? = null,
    val kitHomeImageUrl: String? = null,
    val kitAwayImageUrl: String? = null,
    val formationId: String? = null
)

@Serializable
data class UpdateTeamRequest(
    val name: String? = null,
    val imageUrl: String? = null,
    val kitHomeImageUrl: String? = null,
    val kitAwayImageUrl: String? = null,
    val formationId: String? = null
)

@Serializable
data class AddTeamMemberRequest(
    val userId: String
)

@Serializable
data class UpdateTeamMemberRolesRequest(
    val roles: List<String>
)

@Serializable
data class TeamMatchDto(
    val eventId: String,
    val title: String,
    val status: String,
    val dateTime: String,
    val address: String,
    val format: Int,
    val cost: String,
    val imageUrl: String? = null,
    val result: String? = null,
    val confirmedPlayers: Int,
    val maxPlayers: Int,
    val teamsCount: Int,
    val teams: List<TeamMatchTeamDto>
)

@Serializable
data class TeamMatchTeamDto(
    val eventTeamId: String,
    val name: String,
    val teamId: String? = null,
    val imageUrl: String? = null,
    val color: String? = null,
    val score: Int,
    val isMyTeam: Boolean
)
